
import { BubblyLink } from "../library/src";
import { Button } from 'primereact/button';
import './Nav.css';
import { CancelToken } from 'axios';
import MobileNav from "./MobileNav";
import { useNavigate } from "react-router-dom";
import { TieredMenu } from "primereact/tieredmenu";
import FlexComponent from "../components/FlexComponent";
import logo from '../Images/Breadcrumb_logo.png';
import { useEffect, useRef, useState } from "react";
import { Avatar } from "primereact/avatar";
import { appSubmission, getCustomFields, getOpportunitiesList, getPipelines, registeredUserList, UpdateLeadStage } from "../utils/urls";
import { useSelector } from "react-redux";
import axios from '../utils/axios';
import { NotificationComponent } from "./Notification";
import { InputText } from "primereact/inputtext";
import adminLogo from '../Images/admin_img.jpg';
import formIcon from '../Images/formIcon.png';
import phoneImage from "../Images/favicon_img.png";
import useDebounce from "../components/apps/appsKanban/hooks/useDebounce";
import AppModal from './AppModal';
import AppPopup from "../components/apps/appsKanban/AppPopup";
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from "primereact/progressspinner";

export const Nav = ({ handleLogout, handleLogoutAll, setPipelineName, userId, setBoardSections, isSuperuser, userLable, image, userName, is_leader }) => {
    const navigate = useNavigate();
    const menu = useRef(null);
    const formMenu = useRef(null);
    const superUserFormMenu = useRef(null);
    const appMenuu = useRef(null);
    const pipelineMenu = useRef(null);
    const availabilityMenu = useRef(null);
    const profileImgMenu = useRef(null);
    const userProfileImgMenu = useRef(null);
    const desktopSearchContainerRef = useRef(null);
    const mobileSearchContainerRef = useRef(null);
    const [pipelines, setPipelines] = useState([]);
    const [pipelineId, setPipelineId] = useState("");
    const [pipelineStages, setPipelineStages] = useState();
    const [stageIds, setStageIds] = useState("")
    const [allPipelinesData, setAllPipelinesData] = useState([])
    const [inactivePipelineId, setInactivePipelineId] = useState("")
    const [visible, setVisible] = useState(false);

    const [searchQuery, setSearchQuery] = useState('');
    const [searchData, setSearchData] = useState([]);
    const cancelTokenRef = useRef(null);
    const toast = useRef(null);
    const [isFocused, setIsFocused] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [noDataFound, setNoDataFound] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [applicantData, setApplicantData] = useState();
    const [popupLoad, setPopupLoad] = useState(false);
    const [registeredUsersList, setRegisteredUsersList] = useState([]);
    const [loanDetailsCustomFields, setLoanDetailsCustomFields] = useState([])
    const [realEstateTransactionsCustomFields, setRealEstateTransactionsCustomFields] = useState([])
    const [allCustomFields, setAllCustomFields] = useState([])
    const [isMobileSearchVisible, setIsMobileSearchVisible] = useState(false)
    const mobileInputRef = useRef(null);

    const loanDetailsFields = ["Onedrive Link", "Gdrive Link", "Loan File ID", "Purchase Price", "Loan Amount", "Est. Taxes", "Loan Amount Status", "Closing Date", "Subject Property Address", "Sellers Concession", "First Payment Date", "Insurance Inspection Date"]
    const realEstateTransactionFields = ["Real Estate Gdrive Link"]

    const debouncedSearchQuery = useDebounce(searchQuery, 300);

    // Handle clicks outside both search containers
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutsideDesktop = desktopSearchContainerRef.current && !desktopSearchContainerRef.current.contains(event.target);
            const isOutsideMobile = mobileSearchContainerRef.current && !mobileSearchContainerRef.current.contains(event.target);
            if (isOutsideDesktop && isOutsideMobile) {
                setIsFocused(false);
                setIsMobileSearchVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const MyBubblyLink = ({ to = "", text = "", icon = '', style, className }) => (
        <BubblyLink to={to} setVisible={setVisible} colorStart="#da474e" colorEnd="#ffffff">
            <div className={className} style={style} icon={icon}>
                {text}
            </div>
        </BubblyLink>
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const getAllCustomFields = () => {
        const listUrl = `${getCustomFields}`;
        axios.get(listUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // setAllCustomFields(response.data);
                    let loanDetailsData = response.data.filter(data => loanDetailsFields.includes(data.title))
                    let realEstateTransactionsData = response.data.filter(data => realEstateTransactionFields.includes(data.title))
                    let restCustomFieldsData = response.data.filter(data => !loanDetailsFields.includes(data.title) && !realEstateTransactionFields.includes(data.title))
                    setLoanDetailsCustomFields(loanDetailsData)
                    setRealEstateTransactionsCustomFields(realEstateTransactionsData)
                    setAllCustomFields(restCustomFieldsData)
                }
            })
            .catch((error) => {
                // Handle error
            });
    };

    const openPopupFn = (formId, pipelineId = 1) => {
        setPipelineId(pipelineId);
        setIsFocused(false);
        setIsOpen(true);
        setPopupLoad(true);
        getAllCustomFields();
        const url = `${appSubmission}${formId}?pipelineId=1`;
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const data = response.data;
                    setApplicantData(data);
                    setPopupLoad(false);
                }
            })
            .catch((error) => {
                // Handle error
            });

        const registeredUsersUrl = `${registeredUserList}`;
        axios.get(registeredUsersUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((user) => ({
                        label: user.name,
                        value: user.user_id,
                        image: user.image
                    })) || [];
                    setRegisteredUsersList(options);
                }
            })
            .catch((error) => {
                // Handle error
            });
    };

    const handleSearch = async () => {
        if (!userId || searchQuery.trim().length <= 1) {
            setSearchData([]);
            setSearchLoading(false);
            setNoDataFound(false);
            return;
        }

        // Cancel previous request if it exists
        if (cancelTokenRef.current) {
            cancelTokenRef.current.cancel('Operation canceled due to new request.');
            cancelTokenRef.current = null; // Clear the token to avoid reuse
        }
        cancelTokenRef.current = CancelToken.source();

        setSearchLoading(true);
        setSearchData([]); // Clear previous data
        setNoDataFound(false);

        try {
            const url = `${getOpportunitiesList}?userId=${userId}&pipelineId=1,17&search=${searchQuery}`;
            const response = await axios.get(url, {
                headers: { 'Content-Type': 'application/json' },
                cancelToken: cancelTokenRef.current.token
            });

            if (response.status === 200) {
                // console.log("response-data", response.data);
                // setStageIds(response.data.stage_ids)
                // const stagesData = response.data.stages;
                // const updatedData = Object.values(stagesData).flat();
                const updatedData = response.data
                setSearchData(updatedData);
                setNoDataFound(updatedData.length === 0);
                setSearchLoading(false);
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                // Request was canceled, no state update needed
                return;
            }
            console.error('Search error:', error);
            setSearchData([]);
            setNoDataFound(true);
            setSearchLoading(false);
        }
    };

    useEffect(() => {
        handleSearch();
    }, [userId, debouncedSearchQuery]);

    useEffect(() => {
        if (isMobileSearchVisible && mobileInputRef.current) {
            mobileInputRef.current.focus();
        }
    }, [isMobileSearchVisible]);

    const getAllPipelines = () => {
        if (userId) {
            const url = `${getPipelines}?userId=${userId}`;
            axios.get(url, {
                headers: { 'Content-Type': 'application/json' }
            })
                .then((response) => {
                    if (response.status === 200) {
                        setAllPipelinesData(response?.data)
                        const options = response?.data?.filter((pipeline) => {
                            if (pipeline.name === "Inactive Apps") {
                                setInactivePipelineId(pipeline.id)
                                return false;
                            }
                            return true;
                        })?.map((pipeline) => ({
                            label: pipeline.name,
                            value: pipeline.id,
                        })) || [];
                        setPipelines(options);
                        const stages = response.data
                        const item = stages?.find(item => item.id == 1);
                        setPipelineStages(item.stages)
                    }
                })
                .catch((error) => {
                    // Handle error
                });
        }
    };

    const handleStageUpdate = (contact_id, form_id, stage, prevStage, emails, isLoad = false, stageId = "") => {
        console.log(stage, prevStage)
        console.log("stageIds", stageIds)
        const data = {
            // stage: stage,
            userId: userId,
            stage_id: stageId ? stageId : stageIds[stage],
            email_list: emails
        }
        console.log("datttttttttt", data);

        const stageUrl = `${UpdateLeadStage}${contact_id}/${form_id}`
        axios.post(stageUrl, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Successfully Updated', life: 3000 });
                    if (isLoad) {
                        //     setIsMounted(!isMounted)
                        handleSearch(false)
                    }

                    // setStageAppCounts(prevCounts => ({
                    //     ...prevCounts,
                    //     [stage]: prevCounts[stage] + 1,
                    //     [prevStage]: prevCounts[prevStage] - 1
                    // }))

                    const url = `${appSubmission}${form_id}?pipelineId=${pipelineId}`
                    axios.get(url, {
                        headers: { 'Content-Type': 'application/json' }
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                // console.log(response.data)
                                const data = response.data
                                setBoardSections(prevSections => {
                                    const updatedSections = { ...prevSections };
                                    for (const sectionId in updatedSections) {
                                        updatedSections[sectionId] = updatedSections[sectionId].map(item => {
                                            if (item.form_id === form_id) {
                                                return {
                                                    ...item,
                                                    due_date: data.due_date
                                                };
                                            }
                                            return item;
                                        });
                                    }
                                    return updatedSections;
                                });
                            }
                        })

                }
                else if (response.status === 208) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.data, life: 3000 });
                    handleSearch()
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    handleSearch()
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                handleSearch()
            })
    }

    // console.log(allPipelinesData);


    useEffect(() => {
        getAllPipelines();
    }, [userId]);

    return (
        <FlexComponent flexDirection="column" alignItems="start">
            <Toast ref={toast} />
            <FlexComponent className="navContainer" style={{ width: "100%" }}>
                {isSuperuser ? (
                    <FlexComponent className="navbarDiv" style={{ width: "100%" }}>
                        <nav className="navbar-item animate-in large-nav" style={{ padding: "10px", animationDelay: "100ms", width: "100%" }}>
                            <FlexComponent style={{ width: "100%" }}>
                                <FlexComponent style={{ width: "84.5%" }} className="rightSideNavContainer"  >
                                    <FlexComponent justifyContent="start" gap="1.2rem" style={{ paddingRight: ".5rem", paddingLeft: "2%", width: "auto" }}>
                                        <img className="breadcrumbsLogo" src={logo} onClick={() => navigate("/")} style={{ width: '180px', height: '40px', cursor: "pointer" }} alt="" />
                                        <div ref={desktopSearchContainerRef}>
                                            <span className="p-input-icon-right navbarSearchInput" style={{ width: "auto" }}>
                                                <InputText
                                                    placeholder='Search...'
                                                    onFocus={() => setIsFocused(true)}
                                                    onChange={handleSearchChange}
                                                    value={searchQuery}
                                                    style={{ color: 'white', background: "transparent", borderRadius: "25px", width: "300px", border: "1px solid #575657" }}
                                                />
                                                <i className="pi pi-search" />
                                            </span>
                                            {isFocused && <div style={{ position: "absolute", zIndex: "1000", maxHeight: "50vh", minHeight: searchLoading && "50px", overflow: "auto", background: "black", width: "300px" }}>
                                                {searchLoading ? (
                                                    <FlexComponent justifyContent="center">
                                                        <ProgressSpinner style={{ width: '40px', height: '40px' }} />
                                                    </FlexComponent>
                                                ) : !searchLoading && searchData.length > 0 ? (
                                                    <div>
                                                        {searchData.map((data, index) => (
                                                            <div key={index} className="searchItems" onClick={() => openPopupFn(data.form_id)}>
                                                                {data.full_name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : !searchLoading && noDataFound ? (
                                                    <FlexComponent justifyContent="center">
                                                        <div style={{ color: "white", padding: ".75rem" }}>No Data Found</div>
                                                    </FlexComponent>
                                                ) : null}
                                            </div>}
                                        </div>
                                    </FlexComponent>

                                    <FlexComponent justifyContent="end" gap="1.5rem">
                                        <MyBubblyLink to="/" text="" className="pi pi-home" />

                                        <TieredMenu
                                            model={[
                                                // { label: 'New Mortgage App', command: () => navigate('/new-app-form') },
                                                { label: 'New App', command: () => navigate('/new-app-form') },
                                                // { label: 'Legacy', command: () => navigate('/new-app') },
                                                //hidden { label: 'New Buyer App', command: () => navigate('/new-buyer-app') },
                                                // { label: 'New Loan SetUp Form', command: () => navigate('/new-loan-set-up-form') },
                                                { label: 'Quick App', command: () => navigate('/new-app-short') },
                                                //hidden { label: 'New Homeowner App', command: () => navigate('/new-homeowner-app') },
                                            ]}
                                            popup
                                            ref={superUserFormMenu}
                                            breakpoint="767px"
                                        />
                                        <MyBubblyLink style={{ fontSize: "14px" }} className="pipelineNavs" to={`/app-kanban/1`} text={`Apps`} />
                                        {/* <MyBubblyLink style={{ fontSize: "14px" }} className="pipelineNavs" to={`/app-kanban/17`} text={`Homeowner Apps`} /> */}
                                        <MyBubblyLink style={{ fontSize: "14px" }} className="pipelineNavs" to={`/app-kanban/6`} text={`Clients`} />
                                        {/* {pipelines?.map(item => (
                                            <div key={item.value} style={{ cursor: "pointer" }}>
                                                <MyBubblyLink style={{ fontSize: "14px" }} to={`/app-kanban/${item.value}`} text={`${item.label.replace(/^[^\w]+/, "").trim()}`} />
                                            </div>
                                        ))} */}
                                        <Button
                                            style={{ padding: '0.5rem', background: "transparent", minWidth: "50px" }}
                                            label={<FlexComponent style={{ fontWeight: '400' }}><img src={formIcon} style={{ width: "40px" }} alt="" /></FlexComponent>}
                                            onClick={(e) => superUserFormMenu.current.toggle(e)}
                                        />
                                    </FlexComponent>
                                </FlexComponent>

                                <FlexComponent alignItems='center' className="leftSideNavContainer" justifyContent='end' gap='1rem' style={{ width: "15%", textAlign: 'start' }}>
                                    <NotificationComponent setBoardSections={setBoardSections} allPipelinesData={allPipelinesData} handleStageUpdate={handleStageUpdate} />
                                    {(image || isSuperuser) ? (
                                        <Avatar
                                            style={{ cursor: "pointer", color: '#717B8C', height: "45px" }}
                                            onClick={(e) => profileImgMenu.current.toggle(e)}
                                            image={isSuperuser ? adminLogo : image}
                                            size="large"
                                            shape='circle'
                                        />
                                    ) : (
                                        <Avatar
                                            style={{ cursor: "pointer", color: '#717B8C', height: "45px" }}
                                            onClick={(e) => profileImgMenu.current.toggle(e)}
                                            label={userLable}
                                            size="large"
                                            shape='circle'
                                        />
                                    )}
                                    <TieredMenu
                                        model={[
                                            {
                                                label: 'Leader Board',
                                                items: [
                                                    {
                                                        label: 'Caller Leaderboard',
                                                        icon: 'pi pi-bolt',
                                                        command: () => navigate('/callers-leaderboard')
                                                    },
                                                    {
                                                        label: 'Shopper Leaderboard',
                                                        icon: 'pi pi-server',
                                                        command: () => navigate('/shoppers-leaderboard')
                                                    }
                                                ]
                                            },
                                            {
                                                label: 'Campaign Management',
                                                items: [
                                                    { label: 'Campaigns', command: () => navigate('/campaign') },
                                                    { label: 'Teams', command: () => navigate('/team') },
                                                    { label: 'Participants', command: () => navigate('/participant') },
                                                    { label: 'Purchases', command: () => navigate('/purchase') },
                                                ]
                                            },
                                            {
                                                label: 'Pipelines',
                                                items: pipelines?.map((pipeline) => (
                                                    { label: pipeline.label, command: () => navigate(`/app-kanban/${pipeline.value}`) }
                                                ))
                                            },
                                            {
                                                label: 'Settings',
                                                command: () => navigate('/settings')
                                            },
                                            {
                                                label: 'Repeat Leads',
                                                command: () => navigate('/repeat-leads')
                                            },
                                            {
                                                label: 'Queue',
                                                command: () => navigate('/queue')
                                            },
                                            // {
                                            //     label: 'Pending Closing Queue',
                                            //     icon: 'pi pi-calendar-clock',
                                            //     command: () => navigate('/pending-closing-queue')
                                            // },
                                            {
                                                label: 'Activity Logs',
                                                command: () => navigate('/activity-logs')
                                            },
                                            {
                                                label: 'Help Desk',
                                                command: () => navigate('/help-desk')
                                            },
                                            {
                                                label: 'Real Time Apps',
                                                command: () => navigate('/real-time-apps/1')
                                            },
                                            ...(inactivePipelineId ? [
                                                {
                                                    label: 'Inactive Apps',
                                                    command: () => navigate(`/app-kanban/${inactivePipelineId}`)
                                                }
                                            ] : []),
                                            {
                                                label: 'Library',
                                                items: [
                                                    { label: 'Flyers', command: () => navigate('/library') },
                                                    { label: 'Training & Scripts', command: () => navigate('/training-library') },
                                                ]
                                            },
                                            {
                                                label: 'Logout',
                                                command: () => handleLogout()
                                            },
                                            {
                                                label: 'Log out of all devices',
                                                command: () => handleLogoutAll()
                                            }
                                        ]}
                                        popup
                                        ref={profileImgMenu}
                                        breakpoint="767px"
                                    />
                                    <Button
                                        style={{ padding: '0.5rem', background: "transparent", minWidth: "50px" }}
                                        label={<FlexComponent style={{ fontWeight: '400' }}><img src={phoneImage} style={{ width: "35px", borderRadius: "10px" }} alt="" /></FlexComponent>}
                                        onClick={() => window.open(`https://phone.bcrumbs.com/`, '_blank')}
                                    />
                                </FlexComponent>
                            </FlexComponent>
                        </nav>
                    </FlexComponent>
                ) : (
                    <FlexComponent className="navbarDiv" style={{ width: "100%" }}>
                        <nav className="navbar-item animate-in large-nav" style={{ padding: "10px", animationDelay: "100ms", width: "100%" }}>
                            <FlexComponent style={{ width: "100%" }}>
                                <FlexComponent style={{ width: "84.5%" }} className="rightSideNavContainer" >
                                    <FlexComponent justifyContent="start" gap="1.2rem" style={{ paddingRight: ".5rem", paddingLeft: "2%" }}>
                                        <img className="breadcrumbsLogo" src={logo} onClick={() => navigate("/")} style={{ width: '180px', height: '40px', cursor: "pointer", width: "auto" }} alt="" />
                                        <div ref={desktopSearchContainerRef}>
                                            <span className="p-input-icon-right navbarSearchInput" style={{ width: "auto" }}>
                                                <InputText
                                                    placeholder='Search...'
                                                    onFocus={() => setIsFocused(true)}
                                                    onChange={handleSearchChange}
                                                    value={searchQuery}
                                                    style={{ color: 'white', background: "black", borderRadius: "25px", width: "300px", border: "1px solid #575657" }}
                                                />
                                                <i className="pi pi-search" />
                                            </span>
                                            {isFocused && <div style={{ position: "absolute", zIndex: "1000", maxHeight: "50vh", minHeight: searchLoading && "50px", overflow: "auto", background: "black", width: "300px" }}>
                                                {searchLoading ? (
                                                    <FlexComponent justifyContent="center">
                                                        <ProgressSpinner style={{ width: '40px', height: '40px' }} />
                                                    </FlexComponent>
                                                ) : !searchLoading && searchData.length > 0 ? (
                                                    <div>
                                                        {searchData.map((data, index) => (
                                                            <div key={index} className="searchItems" onClick={() => openPopupFn(data.form_id)}>
                                                                {data.full_name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : !searchLoading && noDataFound ? (
                                                    <FlexComponent justifyContent="center">
                                                        <div style={{ color: "white", padding: ".75rem" }}>No Data Found</div>
                                                    </FlexComponent>
                                                ) : null}
                                            </div>}
                                        </div>
                                    </FlexComponent>

                                    <FlexComponent justifyContent="end" gap="1.5rem">
                                        <MyBubblyLink to="/" text="" className="pi pi-home" />

                                        <TieredMenu
                                            model={[
                                                // { label: 'New Mortgage App', command: () => navigate('/new-app-form') },
                                                { label: 'New App', command: () => navigate('/new-app-form') },
                                                // { label: 'Legacy', command: () => navigate('/new-app') },
                                                //hidden { label: 'New Buyer App', command: () => navigate('/new-buyer-app') },
                                                // { label: 'New Loan SetUp Form', command: () => navigate('/new-loan-set-up-form') },
                                                { label: 'Quick App', command: () => navigate('/new-app-short') },
                                                //hidden { label: 'New Homeowner App', command: () => navigate('/new-homeowner-app') },
                                            ]}
                                            popup
                                            ref={superUserFormMenu}
                                            breakpoint="767px"
                                        />
                                        {/* {pipelines?.map(item => (
                                            <div key={item.value} style={{ cursor: "pointer" }}>
                                                <MyBubblyLink style={{ fontSize: "14px" }} to={`/app-kanban/${item.value}`} text={`${item.label.replace(/^[^\w]+/, "").trim()}`} />
                                            </div>
                                        ))} */}
                                        <MyBubblyLink style={{ fontSize: "14px" }} className="pipelineNavs" to={`/app-kanban/1`} text={`Apps`} />
                                        <MyBubblyLink style={{ fontSize: "14px" }} className="pipelineNavs" to={`/app-kanban/6`} text={`Clients`} />
                                        
                                        <Button
                                            style={{ padding: '0.5rem', background: "transparent" }}
                                            label={<FlexComponent style={{ fontWeight: '400' }}><img src={formIcon} style={{ width: "40px" }} alt="" /></FlexComponent>}
                                            onClick={(e) => superUserFormMenu.current.toggle(e)}
                                        />
                                    </FlexComponent>
                                </FlexComponent>

                                <FlexComponent alignItems='center' className="leftSideNavContainer" justifyContent='end' gap='1rem' style={{ width: "15%", textAlign: 'start' }}>
                                    <NotificationComponent setBoardSections={setBoardSections} allPipelinesData={allPipelinesData} handleStageUpdate={handleStageUpdate} />
                                    {image ? (
                                        <Avatar
                                            style={{ cursor: "pointer", color: '#717B8C', height: "45px" }}
                                            onClick={(e) => userProfileImgMenu.current.toggle(e)}
                                            image={image}
                                            size="large"
                                            shape='circle'
                                        />
                                    ) : (
                                        <Avatar
                                            style={{ cursor: "pointer", color: '#717B8C', height: "45px" }}
                                            onClick={(e) => userProfileImgMenu.current.toggle(e)}
                                            label={userLable}
                                            size="large"
                                            shape='circle'
                                        />
                                    )}
                                    <TieredMenu
                                        model={[
                                            {
                                                label: 'Leader Board',
                                                items: [
                                                    {
                                                        label: 'Caller Leaderboard',
                                                        icon: 'pi pi-bolt',
                                                        command: () => navigate('/callers-leaderboard')
                                                    },
                                                    {
                                                        label: 'Shopper Leaderboard',
                                                        icon: 'pi pi-server',
                                                        command: () => navigate('/shoppers-leaderboard')
                                                    }
                                                ]
                                            },
                                            ...((userId === 35 || userId === 218) ? [
                                                {
                                                    label: 'Campaign Management',
                                                    items: [
                                                        { label: 'Campaigns', command: () => navigate('/campaign') },
                                                        { label: 'Teams', command: () => navigate('/team') },
                                                        { label: 'Participants', command: () => navigate('/participant') },
                                                        { label: 'Purchases', command: () => navigate('/purchase') },
                                                    ]
                                                }
                                            ] : []),
                                            {
                                                label: 'Pipelines',
                                                items: pipelines?.map((pipeline) => (
                                                    { label: pipeline.label, command: () => navigate(`/app-kanban/${pipeline.value}`) }
                                                ))
                                            },
                                            ...((userId === 35 || userId === 218) ? [
                                                {
                                                    label: 'Settings',
                                                    command: () => navigate('/settings')
                                                }
                                            ] : []),
                                            {
                                                label: 'Repeat Leads',
                                                command: () => navigate('/repeat-leads')
                                            },
                                            {
                                                label: 'Queue',
                                                command: () => navigate('/queue')
                                            },
                                            {
                                                label: 'Help Desk',
                                                command: () => navigate('/help-desk')
                                            },
                                            // {
                                            //     label: 'Pending Closing Queue',
                                            //     icon: 'pi pi-calendar-clock',
                                            //     command: () => navigate('/pending-closing-queue')
                                            // },
                                            {
                                                label: 'Real Time Apps',
                                                command: () => navigate('/real-time-apps/1')
                                            },
                                            ...(inactivePipelineId ? [
                                                {
                                                    label: 'Inactive Apps',
                                                    command: () => navigate(`/app-kanban/${inactivePipelineId}`)
                                                }
                                            ] : []),
                                            {
                                                label: 'Library',
                                                items: [
                                                    { label: 'Flyers', command: () => navigate('/library') },
                                                    { label: 'Training & Scripts', command: () => navigate('/training-library') },
                                                ]
                                            },
                                            {
                                                label: 'Availability',
                                                items: [
                                                    {
                                                        label: 'Live Assignment',
                                                        command: () => navigate(`/user-availability/${userId}`)
                                                    },
                                                    {
                                                        label: 'Appointment',
                                                        command: () => navigate(`/user-availability-appointment/${userId}`)
                                                    },
                                                ]
                                            },
                                            ...(is_leader ? [
                                                {
                                                    label: 'Participants',
                                                    command: () => navigate('/participant')
                                                }
                                            ] : []),
                                            {
                                                label: 'Logout',
                                                command: () => handleLogout()
                                            },
                                            {
                                                label: 'Log out of all devices',
                                                command: () => handleLogoutAll()
                                            }
                                        ]}
                                        popup
                                        ref={userProfileImgMenu}
                                        breakpoint="767px"
                                    />
                                    <Button
                                        style={{ padding: '0.5rem', background: "transparent", minWidth: "50px" }}
                                        label={<FlexComponent style={{ fontWeight: '400' }}><img src={phoneImage} style={{ width: "35px", borderRadius: "10px" }} alt="" /></FlexComponent>}
                                        onClick={() => window.open(`https://phone.bcrumbs.com/`, '_blank')}
                                    />
                                </FlexComponent>
                            </FlexComponent>
                        </nav>
                    </FlexComponent>
                )}
            </FlexComponent>

            <FlexComponent flexDirection="column">
                <FlexComponent className="navContainer" style={{ top: 40, marginLeft: "4vw", width: "90vw", background: "black" }}>
                    <MobileNav isSuperuser={isSuperuser} is_leader={is_leader} handleLogout={handleLogout} pipelines={pipelines} userId={userId} inactivePipelineId={inactivePipelineId} />
                    {/* <FlexComponent justifyContent="center" > */}
                        <img className="mobile-nav" src={logo} onClick={() => navigate("/")} style={{ width: '180px', height: '40px', cursor: "pointer" }} alt="" />
                    {/* </FlexComponent> */}
                        {<Button className="mobile-nav" style={{ visibility : isMobileSearchVisible && "hidden", boxShadow: "none", marginTop: ".4rem", textAlign: "end", padding: ".75rem" }} onClick={() => {
                            setIsMobileSearchVisible(!isMobileSearchVisible)
                        }} icon="pi pi-search" />}
                </FlexComponent>
                <div className="mobile-nav" style={{ marginTop: ".5rem", width: "100%" }}>
                    <div ref={mobileSearchContainerRef}>
                        {<div
                            className={`mobile-search-wrapper ${isMobileSearchVisible ? "open" : ""}`}
                        >
                            <span className="p-input-icon-right" style={{  paddingBottom: ".4rem", padding: "0px 5px", }}>
                                <InputText
                                    placeholder=''
                                    ref={mobileInputRef}
                                    onFocus={() => setIsFocused(true)}
                                    onChange={handleSearchChange}
                                    value={searchQuery}
                                    style={{ color: 'white', width: "100%", background: "rgb(78 77 77 / 61%)", backdropFilter: "blur(1px)", borderRadius: "10px",  border: "1px solid #575657" }}
                                />
                                <i className="pi pi-search" />
                            </span>
                        </div>}

                        {isFocused && <div style={{ position: "absolute", zIndex: "1000", maxHeight: "50vh", minHeight: searchLoading && "50px", overflow: "auto", background: "black", width: "100%" }}>
                            {searchLoading ? (
                                <FlexComponent justifyContent="center">
                                    <ProgressSpinner style={{ width: '40px', height: '40px' }} />
                                </FlexComponent>
                            ) : !searchLoading && searchData.length > 0 ? (
                                <div>
                                    {searchData.map((data, index) => (
                                        <div key={index} className="searchItems" onClick={() => openPopupFn(data.form_id)}>
                                            {data.full_name}
                                        </div>
                                    ))}
                                </div>
                            ) : !searchLoading && noDataFound ? (
                                <FlexComponent justifyContent="center">
                                    <div style={{ color: "white", padding: ".75rem" }}>No Data Found</div>
                                </FlexComponent>
                            ) : null}
                        </div>}
                    </div>
                </div>
            </FlexComponent>

            <AppModal visible={isOpen} onHide={handleClose}>
                <div style={{ marginTop: '1rem', minHeight: "70vh" }}>
                    {!popupLoad ? (
                        <AppPopup
                            applicantData={applicantData}
                            pipelineId={pipelineId}
                            id={applicantData?.app_status}
                            setApplicantData={setApplicantData}
                            pipelineStages={pipelineStages}
                            allPipelinesData={allPipelinesData}
                            isFromSearch={true}
                            isFromTable={true}
                            allCustomFields={allCustomFields}
                            loanDetailsCustomFields={loanDetailsCustomFields}
                            realEstateTransactionsCustomFields={realEstateTransactionsCustomFields}
                            setBoardSections={setBoardSections}
                            handleStageUpdate={handleStageUpdate}
                            usersList={registeredUsersList}
                            userId={userId}
                            handleClose={handleClose}
                            toast={toast}
                        />
                    ) : (
                        <FlexComponent flexDirection="column" justifyContent="center">
                            <div style={{ minWidth: "40vw", height: "100%" }} className='loadingAppItem'></div>
                        </FlexComponent>
                    )}
                </div>
            </AppModal>
        </FlexComponent>
    );
};
